import axios from 'axios'
import Cookies from 'js-cookie'
// 请求数据正常状态
export const ERR_OK = 8200
// 页面渲染延时
export const TIME_QUERY = 500

export const imageCDN = process.env.IMAGE_CDN
export const baseUrl = 'http://192.168.0.163:9105'

//线上
// export const baseUrl = 'http://192.168.0.118:9104'
// export const baseUrl2 = 'http://120.24.165.218:10120'
export const baseImgUrl = process.env.BASE_URL

// 请求超时时间
axios.defaults.timeout = 5000

// respone拦截器
axios.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    let {data} = response
    
    if (data.message === 'token failure!') {
      localStorage.removeItem('token')
      localStorage.removeItem('UserName')
      localStorage.removeItem('Password')
      localStorage.removeItem('token')
      window.location.href = '#/'
    } else {
      
      return Promise.resolve(response)
    }
    // 50014:Token 过期了 50012:其他客户端登录了 50008:非法的token
  },
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)

//登录
export function fetch(requestUrl, params = '') {
  // const token = Cookies.get('token') === undefined ? '11111' : Cookies.get('token')
  const token = localStorage.getItem('token') === null ? '' : localStorage.getItem('token')
  return axios({
    url: requestUrl,
    method: 'post',
    data: {
      'account': params.account,
      // "password":params.password,
      "verCode":params.password,
      "signType":0
    },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'operatortoken': token
    }
  })
}



/*账号管理*/
  //获取账号列表
  export function accountlist(requestUrl, params = ''){
    const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
    return axios({
      url: requestUrl,
      method: 'post',
      data: {
        "search_text":params.search_text,
        "companyId":params.companyId
      },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'operatortoken': "bearer "+token
      }
    })
  }
  //添加帐号
  export function accountadd(requestUrl, params = ''){
    const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
    return axios({
      url: requestUrl,
      method: 'post',
      data: {
        "name":params.name,
        "password":params.password,
        "account":params.account,
        "companyId":params.companyId,
        "status":params.status
      },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'operatortoken': "bearer "+token
      }
    })
  }
  //编辑账号
  
  export function accountedit(requestUrl, params = ''){
    const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
    return axios({
      url: requestUrl,
      method: 'post',
      data: {
        "name":params.name,
        "password":params.password,
        "id":params.id,
        "status":params.status
      },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'operatortoken': "bearer "+token
      }
    })
  }
  
  //删除账号
  export function accountdet(requestUrl, params = ''){
    const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
    return axios({
      url: requestUrl,
      method: 'post',
      data: {
        "id":params.id,
        "account":params.account
      },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'operatortoken': "bearer "+token
      }
    })
  }
  

/*上传图片*/
export function uploadimg(requestUrl, params = ''){
  const data_json = new FormData();
  data_json.append("file", params.file);
  const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
    
    return axios({
      url: requestUrl,
      method: 'post',
      data:data_json,
      headers: {
        'Content-Type': 'multipart/form-data',
        'operatortoken': "bearer "+token
      }
    })
    
}


//统一post
export function fetchpost(requestUrl, params = ''){
  const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
  return axios({
    url: requestUrl,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'operatortoken': "bearer "+token
    }
  })
}

export function fetchposts(requestUrl, params = ''){
  return axios({
    url: requestUrl,
    method: 'post',
    data: params,
  })
}
//统一get
export function fetchget(requestUrl){
  const token = sessionStorage.getItem('token') === null ? '' : sessionStorage.getItem('token')
  return axios({
    url: requestUrl,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'operatortoken': "bearer "+token
    }
  })
}



export function fetchlogin(requestUrl, params = '') {
  // const token = Cookies.get('token') === undefined ? '11111' : Cookies.get('token')
  const token = localStorage.getItem('token') === null ? '' : localStorage.getItem('token')
  return axios({
    url: requestUrl,
    method: 'post',
    data: {
      'account': params.account,
      "password":params.password
    },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'operatortoken': token
    }
  })
}

export function fetchapi(requestUrl, params = '') {
  // const token = Cookies.get('token') === undefined ? '11111' : Cookies.get('token')
  const token = localStorage.getItem('token') === null ? '' : localStorage.getItem('token')
  return axios({
    url: `${baseUrl}api/standardCheck`,
    method: 'post',
    data: {
      'requestId': 'xxxxxx-xxxxxx-xxxxx-xxxxx',
      'apiKey': 'highstore',
      'uri': requestUrl,
      'lang': 'zh-cn',
      'timeZone': '+8:00',
      'sign': ' xxxxxxxxxxxxxxxxxxxxxx',
      'body': params
    },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'operatortoken': token
    }
  })
}


export function getCookies(params) {
  return Cookies.get(params) || ''
}

export function setCookies(memberNo, openid, token) {
  Cookies.set('memberNo', memberNo)
  Cookies.set('openid', openid)
  Cookies.set('token', token)
}




// WEBPACK FOOTER //
// ./src/config/index.js